export const buildNum = '12961';
export const buildEnvironment = 'production';
